import axios from 'axios';
import i18n from '../../config/i18n';
import { toast } from 'react-toastify';

const API_BASE_URL =
    process.env.REACT_APP_ENV === 'production'
        ? 'https://api.my.sltp.eu/api/v1'
        : process.env.REACT_APP_ENV === 'test'
          ? 'https://api.test.my.sltp.eu/api/v1'
          : 'http://localhost:8081/api/v1';

export const apiClient = axios.create({
    baseURL: API_BASE_URL,
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json',
    },
});

apiClient.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response) {
            const { status, data } = error.response;
            const apiMessage = data?.message;

            let errorMessage = '';

            if (status === 401 || status === 403) {
                return Promise.reject(error);
            }

            if (typeof apiMessage === 'string') {
                errorMessage = i18n.exists(apiMessage) ? i18n.t(apiMessage) : apiMessage;
            } else {
                switch (status) {
                    case 400:
                        errorMessage = i18n.t('badRequestError');
                        break;

                    case 404:
                        errorMessage = i18n.t('notFoundError');
                        break;
                    case 500:
                        errorMessage = i18n.t('serverError');
                        break;
                    default:
                        errorMessage = i18n.t('unknownError');
                        break;
                }
            }
            toast.error(errorMessage);
            return Promise.reject(error);
        }

        toast.error(i18n.t('unknownError'));
        return Promise.reject(error);
    }
);
